export default {
	memo_communication_type: 'Kommunikationsart',
	memo_created_for_label: 'Angelegt für',
	memo_datefield_close: 'Schließen',
	memo_delete_dialog_confirm_cancel_label: 'Nein',
	memo_delete_dialog_confirm_message: 'Möchten Sie diese Aktennotiz wirklich löschen?',
	memo_delete_dialog_confirm_ok_label: 'Ja',
	memo_delete_dialog_confirm_title: 'Aktennotiz löschen',
	memo_duration_label: 'Dauer',
	memo_fixed_description_label: 'Beschreibung',
	memo_fixed_maturity_date_label: 'Datum',
	memo_notepad_placeholder: 'Hier persönliche Notizen eingeben...',
	memo_notepad_title: 'Notiz',
	memo_save_failed_notification: 'Aktennotiz konnte nicht gespeichert werden',
	memo_saved_notification: 'Aktennotiz wurde gespeichert',
	memo_text_color_editor_label: 'Farben',
};
